
function Header() {
    return (
        <header>
           <h2>
            
        </h2> 
        </header>
        
    );
}

export default Header;